import styled from "styled-components";
import { FlexRow } from "styles/layout";

export const TeamSelector = styled("button")<{ selected: boolean }>`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  border: 1px solid black;
  width: 210px;
  height: 38px;
  &:disabled {
    cursor: auto;
    color: black;
  }

  ${({ selected }) =>
    selected &&
    "border: 4px solid MediumSeaGreen; color: MediumSeaGreen; padding: 2px;"}
`;

export const TeamSelectorContent = styled(FlexRow)<{ disabled: boolean }>`
  font-size: 13pt;

  ${({ disabled }) => disabled && "opacity: 0.5"}
`;

export const LogoContainer = styled.div`
  width: 24px;
  height: 24px;
  padding-right: 4px;
`;
